import TsTabs from './Tabs.vue'
import TsTab from './Tab.vue'
import TsTabPanes from './TabPanes.vue'
import TsTabPane from './TabPane.vue'

export { TsTabs, TsTab, TsTabPanes, TsTabPane }
